<template>
  <div class="playlisttable">
    <enfold-ucd>
      <template slot="up">
        <div class="topcon">
          <div class="c-u-left" @click="deletes"></div>
          <div class="c-u-right">
            <div class="search_input">
              <el-input v-model="key_word" :placeholder="$t('terminal.keyWord')" size="mini">
                <i slot="suffix" class="el-icon-search" @click="playsearch"></i>
              </el-input>
            </div>
          </div>
        </div>
      </template>

      <template slot="center">
        <el-table style="width: 100%" ref="multipleTable" :data="play_data" height="100%" @row-click="selectRow" @selection-change="selectionLineChangeHandle" :row-key="getRowKey" v-loading="loading">
          <el-table-column type="selection" :reserve-selection="true" align="center"></el-table-column>
          <el-table-column prop="publish_no" :label="$t('schedule.playNo')" sortable>
            <template slot-scope="scope">
              <template v-if="scope.row.damaged===1">
                <span style="color: red;">{{scope.row.publish_name||scope.row.publish_no}}</span>
              </template>
              <template v-if="scope.row.damaged===0">
                <span>{{scope.row.publish_name||scope.row.publish_no}}</span>
              </template>
            </template>
          </el-table-column>
          <el-table-column prop="group_name" :label="$t('schedule.group')"></el-table-column>
          <el-table-column :label="$t('schedule.releaseType')">
            <template slot-scope="scope">
              <template v-if="scope.row.publish_type===1">{{$t('schedule.releaseNow')}}</template>
            </template>
          </el-table-column>
          <el-table-column prop="publish_time" :label="$t('schedule.releaseTim')" sortable>
            <template slot-scope="scope">
              <template v-if="scope.row.publish_time==''&&scope.row.publish_time!=null">
                --
              </template>
              <template v-else>
                {{scope.row.publish_time}}
              </template>
            </template>
          </el-table-column>
          <el-table-column prop="user_name" :label="$t('schedule.publisher')">
            <template slot-scope="scope">
              {{`${scope.row.user_name.substring(scope.row.user_name.indexOf('&')+1,scope.row.user_name.length)}`}}
            </template>
          </el-table-column>
          <el-table-column :label="$t('schedule.review')" sortable>
            <template slot-scope="scope">
              <span v-if="scope.row.publish_state==0">{{$t('schedule.pedReview')}}</span>
              <span v-if="scope.row.publish_state==-1">{{$t('schedule.noReview')}}</span>
              <span v-if="scope.row.publish_state==1">{{$t('schedule.noPass')}}</span>
              <span v-if="scope.row.publish_state==2" class="greenfont">{{$t('schedule.pass')}}</span>
              <span v-if="scope.row.publish_state==3">{{$t('schedule.waitRelease')}}</span>
              <span v-if="scope.row.publish_state==10">{{$t('schedule.expird')}}</span>
            </template>
          </el-table-column>
          <el-table-column :label="$t('schedule.operate')">
            <template slot-scope="scope">
              <div style="display: flex;">
                <popovers :content="$t('schedule.detail')">
                  <img class="con-img" src="@/assets/images/public/public_detail.png" @click="handleDetail(scope.row)" />
                </popovers>
                <!-- <el-tooltip class="item" effect="dark" content="编辑" placement="top-start">
									<div class="edit"></div>
									<img class="con-img" src="@/assets/images/public/public_edit.png"/>
								</el-tooltip> -->
                <popovers :content="$t('schedule.delete')">
                  <img class="con-img" src="@/assets/images/public/public_delete.png" @click="handleDelete(scope.row.id)" />
                </popovers>
              </div>

              <!-- <template v-if="scope.row.publish_state==2||scope.row.publish_state==-1||scope.row.publish_state==-3">
								<el-tooltip class="item" effect="dark" content="发布" placement="top-start">
								
								<img class="con-img" src="@/assets/images/public/public_release.png" @click="handleRelease(scope.row.publish_state)" />
								</el-tooltip>
							</template> -->
            </template>
          </el-table-column>
        </el-table>
      </template>
      <!-- 翻页 -->
      <template slot="down">
        <div class="control">
          <el-pagination align='center' @current-change="handleCurrentChange" :current-page="current_page" :page-sizes="[4]" :page-size="pagesize" background layout="prev,pager,next" :total="totalCount" class="elpa" hide-on-single-page>
          </el-pagination>
        </div>

        <plan-detail-dialog :detailDialogVisible="detailDialogVisible" @changeShow="showAdd" :detailId="Number(detailId)"></plan-detail-dialog>

        <!-- <el-dialog title="提示" :visible.sync="deleteDialogVisible" width="30%" :before-close="handleConfirm"
					:append-to-body='true'>
					<span>确认删除？</span>
					<span slot="footer" class="dialog-footer">
						<el-button @click="deleteDialogVisible = false">取 消</el-button>
						<el-button type="primary" @click="confirmDelete">确 定</el-button>
					</span>
				</el-dialog> -->
        <del-dialog :dialogVisible="DelDialogVisible" @closeDialog="DelCloseDialog" :title="$t('schedule.deletePlay')">
          <div class="dd-dialog">{{$t('schedule.deletePlayTip')}}</div>
        </del-dialog>
        <release-play :deviceDialogVisible="deviceDialogVisible" @changeShow="showDevice"></release-play>

      </template>
    </enfold-ucd>
    <publish-check class="publish-check" :title="$t('csp1')" :isVisible="mtCheckVisible" :current_detail="current_detail" :play_table_list="play_table_list" :deviceList="deviceList" :publishInfo="publishInfo" :scheduleList="scheduleList" :isAppend="true" @closeCheck="closeCheck"></publish-check>
  </div>
</template>

<script>
import {
  runStateInfo
} from "@/assets/scripts/runState";
import PlanDetailDialog from './children/PlanDetailDialog.vue'
import EnfoldUcd from '@/components/basics/EnfoldUCD'
import DelDialog from './children/DelDialog.vue'
import ReleasePlay from './children/ReleasePlay.vue'
import PublishCheck from '@/components/review/children/PublichCheck';
import Popovers from "@/components/basics/Popover";
//import DelDialog from '@/components/basics/DelDialog'
export default {
  name: "PlayListTable",
  components: {
    PlanDetailDialog,
    EnfoldUcd,
    DelDialog,
    ReleasePlay,
    PublishCheck,
    Popovers
  },
  data() {
    return {
      play_table_list: [],
      deviceList: [],
      publishInfo: [],
      current_detail: {},
      scheduleList: [],
      detailDialogVisible: false,
      deleteDialogVisible: false,
      deviceDialogVisible: false,
      DelDialogVisible: false,
      mtCheckVisible: false,
      loading: false,
      play_data: [],
      pagesize: 4,
      searchdata: null,
      key_word: null,
      totalCount: null,
      fabu_play: null,
      current_page: 1,
      detailId: null,
      deleteId: null,
      playList: []
    }
  },
  methods: {
    selectRow(row) {
      this.$refs.multipleTable.clearSelection();
      this.$refs.multipleTable.toggleRowSelection(row,
        true);
    },
    selectionLineChangeHandle(val) {
      this.fabu_play = val
    },
    getRowKey(row) {
      return row.id
    },
    handleCurrentChange(val) {
      this.current_page = val;
      this.planAdd()
    },
    planAdd() {
      this.getPublishList();
      // const group_ids = sessionStorage.getItem('group_ids');
      // this.loading = true;
      // this.$http.post("/admin/publish/list", {
      //   //limit,
      //   list_rows: 4,
      //   page: this.current_page,
      //   group_ids,
      //   key_word: ''
      // }, info => {
      //   this.totalCount = Number(info.total);
      //   this.play_data = info.data;
      //   this.current_page = info.current_page;
      //   this.loading = false;
      // });
    },
    playsearch() {
      if (this.key_word == null) {
        this.$msg({
          showClose: true,
          message: this.$t('terminal.keyWords'),
          type: 'warning'
        });
      } else {
        this.getPublishList();
        // this.loading = true;
        // this.$http.post("/admin/publish/list", {
        //   //limit,
        //   list_rows: 4,
        //   page: this.current_page,
        //   group_ids,
        //   key_word: this.key_word
        // }, info => {
        //   this.totalCount = Number(info.count);
        //   this.play_data = info.data;
        //   this.current_page = info.current_page;
        //   this.loading = false
        // });
      }
    },
    async handleDetail(detail) {
      // console.log(detail);
      await this.$http.post('/admin/publish/detail', {
        publish_id: detail.id,
        play_ids: detail.play_ids
      }, response => {
        const { publishDetail: { schedule_list } } = response;
        this.publishInfo = [];
        this.scheduleList = schedule_list ? schedule_list : [];
        this.deviceList = response.publishDetail.devices;
        this.playList = response.publishDetail.playlist;
        this.publishInfo.push(response.publishInfo);

        this.deviceList.forEach((ele) => {
          ele.runStateInfo = runStateInfo(ele.run_state, ele.group_run_status);
        })
      })
      let play_ids = [];
      await this.playList.forEach((ele => {
        play_ids.push(ele.id)
      }));

      await this.$http.post('/admin/play/list', {
        group_ids: sessionStorage.getItem('group_ids'),
        limit: 1000,
        page: 1,
        play_ids: play_ids.toString()
      }, response => {
        console.log(response);
        this.play_table_list = response.list;
      })
      this.mtCheckVisible = true;
      //this.detailId = detail
      //this.detailDialogVisible = true
    },
    closeCheck() {
      this.mtCheckVisible = false;
    },
    handleDelete(id) {
      console.log(id)
      this.DelDialogVisible = true;
      this.deleteId = id
    },
    DelCloseDialog(isConfirm) {
      if (isConfirm) {
        //删除
        const group_ids = sessionStorage.getItem('group_ids');
        this.$http.post("/admin/publish/del", {
          //limit,
          group_ids,
          ids: this.deleteId
        }, info => {
          console.log(info.tips)
          this.planAdd()
        });
        this.fabu_play = null;
        this.$refs.multipleTable.clearSelection();
        this.getPublishList();
        // this.loading = true
        // this.$http.post("/admin/publish/list", {
        //   //limit,
        //   list_rows: 4,
        //   page: this.current_page,
        //   group_ids,
        //   key_word: ''
        // }, info => {
        //   this.totalCount = Number(info.total);
        //   this.play_data = info.data;
        //   this.current_page = info.current_page;
        //   this.loading = false
        // });
      }
      this.delProgramIds = "";
      this.DelDialogVisible = false;
    },
    handleRelease(state) {
      console.log(state)
      this.deviceDialogVisible = true
    },
    showAdd(data) {
      if (data === 'false') {
        this.detailDialogVisible = false
      } else {
        this.detailDialogVisible = true
      }
    },
    showDevice(data) {
      if (data === 'false') {
        this.deviceDialogVisible = false
      } else {
        this.deviceDialogVisible = true
      }
    },
    handleConfirm(done) {
      this.$confirm(this.$t('csp2'))
        .then(_ => {
          done();
          console.log(_)
        })
        .catch(_ => {
          console.log(_)
        });
    },
    confirmDelete() {
      //已写好
      const group_ids = sessionStorage.getItem('group_ids');
      this.$http.post("/admin/fabu/del", {
        //limit,
        group_ids,
        id: this.deleteId
      }, info => {
        console.log(info)
      });
      this.deleteDialogVisible = false
    },
    deletes() {
      if (this.fabu_play == null) {
        this.$msg({
          message: this.$t('schedule.noSelectTip'),
          type: 'warning'
        })
      } else {
        let delete_ids = ''
        for (let i = 0; i < this.fabu_play.length; i++) {
          delete_ids += this.fabu_play[i].id + ','
          //delete_ids.push(this.fabu_play[i].id)
        }
        let ids = delete_ids.substring(0, delete_ids.length - 1)
        this.deleteId = ids;
        this.DelDialogVisible = true;
        console.log('.....', ids)
      }

    },
    getPublishList() {
      const group_ids = sessionStorage.getItem('group_ids');
      this.loading = true
      this.$http.post("/admin/publish/list", {
        //limit,
        list_rows: 4,
        page: this.current_page,
        group_ids,
        key_word: ''
      }, info => {
        this.totalCount = Number(info.total);
        this.play_data = info.data;
        this.current_page = info.current_page;
        this.loading = false
      });
    },
  },
  mounted() {
    this.getPublishList();
  },
  // mounted: function () {
  //   const group_ids = sessionStorage.getItem('group_ids');
  //   this.loading = true
  //   this.$http.post("/admin/publish/list", {
  //     //limit,
  //     list_rows: 4,
  //     page: this.current_page,
  //     group_ids,
  //     key_word: ''
  //   }, info => {
  //     this.totalCount = Number(info.total);
  //     this.play_data = info.data;
  //     this.current_page = info.current_page;
  //     this.loading = false
  //   });
  // }
}
</script>

<style lang="scss" scoped>
// .publish-check /deep/ .el-dialog__wrapper >.el-dialog--center > .el-dialog__header{
// 	background-color: orange;
// }
.con-img {
  width: 30px;
  height: 30px;
  cursor: pointer;
}

.topcon {
  display: flex;
  justify-content: space-between;
  /* position: relative; */
  /* padding-left: 1%;
		padding-right: 1%; */

  width: 100%;
  align-items: center;
}

.c-u-left {
  height: 30px;
  width: 30px;
  cursor: pointer;
  background-image: url(~@/assets/images/public/public_delete.png);
  background-size: 100%;
  background-position: center;
  /* position: absolute;
		left: 0;
		top: 0; */
}

.topdelete:hover {
  cursor: pointer;
}

.c-u-right {
  width: 280px;
}

.c-u-right {
  /deep/ .el-input__inner {
    height: 30px;
    line-height: 30px;
    border-radius: 15px;
  }

  /deep/ .el-input__suffix {
    line-height: 30px;
    color: #2fb3ff;
    font-size: 16px;
    right: 10px;
  }
}

.search /deep/ .el-input__inner {
  border-top-left-radius: 30px;
  border-bottom-left-radius: 30px;
  background-color: #edfbff;
  border: 0;
}

.search /deep/ .el-button--default {
  background-color: #edfbff;
  border-left-style: none;
  border-left: 0;
}

/deep/ .el-table__header-wrapper {
  .cell {
    font-size: 18px;
    color: #2fb3ff;
  }
  .el-table__header tr,
  .el-table__header th {
    padding: 6.5px 0 !important;
  }
}

/deep/ th:last-child > .cell {
  text-align: center;
}

.col {
  float: left;
}

.playlisttable {
  width: 101%;
  height: 52%;
  background-color: white;
}

.icon {
  /* margin: 20px auto; */
  /* box-sizing: border-box; */
  width: 100%;
  height: 100%;
  text-align: center;
  display: flex;
  justify-content: space-around;
}

.icon div {
  flex-basis: 12%;
  height: 1.5vw;
  background-size: 100%;
  background-position: center;
}

.detail {
  background-image: url(~@/assets/images/public/public_detail.png);
}

.edit {
  background-image: url(~@/assets/images/public/public_edit.png);
}

.delete {
  background-image: url(~@/assets/images/public/public_delete.png);
}

.release {
  background-image: url(~@/assets/images/public/public_release.png);
}

.control {
  background-color: white;
  width: 100%;
  position: fixed;
  bottom: 0;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 9;
}

.greenfont {
  font-weight: bold;
  font-family: PingFang-SC-Regular;
  font-stretch: normal;
  letter-spacing: 0px;
  color: #47dce1;
}
</style>
